import { jsx as _jsx } from "react/jsx-runtime";
import { AwaitModules, ComponentSync } from '@nu-art/thunderstorm-frontend/index';
import './DeleteConfirmation_Body.scss';
import { Discussion_Renderer } from '../Discussion_Renderer.js';
import { ModuleFE_Account } from '@nu-art/user-account-frontend/index';
import { ModuleFE_Message } from '@nu-art/ts-messaging-frontend';
import { ModuleFE_Discussion } from '@app/hcs-frontend';
import { ModuleFE_User } from '../../../../_entity/user/index.js';
const modulesToAwait = [ModuleFE_Discussion, ModuleFE_User, ModuleFE_Account, ModuleFE_Message];
export class DeleteConfirmation_Body extends ComponentSync {
    deriveStateFromProps(nextProps, state) {
        return state;
    }
    render() {
        return _jsx(AwaitModules, { modules: modulesToAwait, children: _jsx("div", { className: 'dialogue-body', children: _jsx(Discussion_Renderer, { discussion: this.props.discussion, disabled: true }) }) });
    }
}
//# sourceMappingURL=DeleteConfirmation_Body.js.map